import axios from "axios";

const USER_API_BASE_URL = process.env.REACT_APP_SERVER_PATH;
const REACT_APP_AD_URL = process.env.REACT_APP_AD_URL;

class AuthService {
    login(credentials) {
        return axios.post(USER_API_BASE_URL + "/token/", credentials);
    }

    getUserInfo() {
        return JSON.parse(localStorage.getItem("userInfo"));
    }

    getAuthHeader() {
        let access = localStorage.getItem("access");
        if (access === undefined || access === "" || access === null) {
            localStorage.setItem("access", "tempTokenGetAuthHeader");
            window.location.href = REACT_APP_AD_URL;
        }
        return { headers: { Authorization: "Bearer " + access } };
    }

    async verifyAccount() {
        let url = `${window.location.href.replaceAll(window.location.origin + "/?", process.env.REACT_APP_SERVER_PATH + "/profiles/verify/?state=12345&challenge=YTFjNjI1OWYzMzA3MTI4ZDY2Njg5M2RkNmVjNDE5YmEyZGRhOGYyM2IzNjdmZWFhMTQ1ODg3NDcxY2Nl&")}&reply_url=${process.env.REACT_APP_AD_REPLY_URL}`;
        await axios.get(url).then(async (res) => {
            if (res.data.access && res.data.access !== undefined && res.data.access !== null && res.data.refresh && res.data.refresh !== undefined) {
                await localStorage.setItem("userInfo", JSON.stringify(res.data));
                await localStorage.setItem("access", res.data.access);
                await localStorage.setItem("refresh", res.data.refresh);
                await localStorage.setItem("role", res.data.role);
                if (res.data.ad_response && res.data.ad_response.displayName) localStorage.setItem("name", res.data.ad_response.displayName);
                if (res.data.ad_response) localStorage.setItem("basic", JSON.stringify(res.data.ad_response));
                // history.push('/')
                window.location.href = "/";
            }
        });
    }

    async refreshToken() {
        let isValid = true;
        if (window.location.pathname !== "/login") {
            if (window.location.href.split("?code=").length > 1) {
                console.log("Verifying the account...");
                await this.verifyAccount();
            } else {
                console.log("Verifying the token...");
                let access = localStorage.getItem("access");
                await axios
                    .post(USER_API_BASE_URL + "/token/verify/", {
                        token: access,
                    })
                    .then(() => {})
                    .catch(async () => {
                        console.log("Refreshing the token...");
                        await axios
                            .post(USER_API_BASE_URL + "/token/refresh/", {
                                refresh: localStorage.getItem("refresh"),
                            })
                            .then((res) => {
                                if (res.data && res.data.access) {
                                    localStorage.setItem("access", res.data.access);
                                    isValid = true;
                                } else {
                                    isValid = true;
                                    // Enable following line after updating the Backend
                                    window.location.href = REACT_APP_AD_URL;
                                }
                            })
                            .catch((exception) => {
                                console.log(exception, "Exception");
                                this.logOut();
                            });
                    });
            }
        } else {
            console.log("refreshToken else block - tempToken");
            localStorage.setItem("access", "tempTokenRefreshTokenElseBlock");
        }
        return isValid;
    }

    async verifyToken() {
        await axios
            .post(USER_API_BASE_URL + "/token/verify/", {
                token: this.getUserInfo().refresh,
            })
            .then((res) => {
                console.log(res.data);
            });
    }

    async logOut() {
        localStorage.removeItem("userInfo");
        localStorage.setItem("access", "tempTokenLogOut");
        window.location.replace("/login");
    }
}

export default new AuthService();
